import { applyMiddleware, combineReducers, compose, createStore as _createStore } from 'redux';
import { withExtraArgument } from 'redux-thunk';

import { newbuildingReducer, openedPhonesReducer } from '../../reducers';
import { IApplicationContext } from '../../types/applicationContext';
import { IApplicationState, IReduxStore, TReduxActions, TThunkDispatch } from '../../types/redux';
import { promoInfoReducer } from '../../reducers/promoInfo';
import { userReducer } from '../../reducers/user';

interface IThunkExt {
  dispatch: TThunkDispatch;
}

let storeReminder: IReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(context: IApplicationContext, initialState: IApplicationState, debugEnabled: boolean) {
  const reducers = combineReducers({
    newbuilding: newbuildingReducer,
    openedPhones: openedPhonesReducer,
    promo: promoInfoReducer,
    user: userReducer,
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(applyMiddleware(withExtraArgument(context)));

  const createStore = (): IReduxStore =>
    _createStore<IApplicationState, TReduxActions, IThunkExt, {}>(reducers, initialState, storeEnchancers);

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
